// extracted by mini-css-extract-plugin
module.exports = {"cardDialog":"AuthWithCard_cardDialog__1cId7","reader":"AuthWithCard_reader__Rjj5A","state":"AuthWithCard_state__1k6qr","hint":"AuthWithCard_hint__sQQy1"};